<template>
<div class="modal" v-show="judge">
  <Style             :boxData="boxData" :dataMsg="dataMsg"/>
  <Internet          :boxData="boxData" :dataMsg="dataMsg"/>
  <UploadFilLoading  :boxData="boxData" :dataMsg="dataMsg"/>
  <Preview           :boxData="boxData" :dataMsg="dataMsg"/>
  <Hand              :boxData="boxData" :dataMsg="dataMsg"/>
  <Writehand         :boxData="boxData" :dataMsg="dataMsg"/>
  <QuickManu         :boxData="boxData" :dataMsg="dataMsg"/>
  <DelVip            :boxData="boxData" :dataMsg="dataMsg" :boxType="boxType" />

</div>

</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from 'vuex'

import Style             from './modal/style.vue'                 // 风格选择模态框
import Internet          from './modal/isInternet.vue'            // 风格选择模态框
import UploadFilLoading  from './modal/uploadFilLoading.vue'      // 上传loading
import Preview           from './modal/preview.vue'               // 全局播放模态框
import Hand              from './modal/hand.vue'                  // 选择手势
import Writehand         from './modal/writehand.vue'             // 选择手势
import QuickManu         from './modal/quickManu.vue'             //
import DelVip            from './modal/deleteVipSprites.vue'      // 删除vip元素弹窗

export default {
  data() {
    return {
      judge   : false,    // 判断是否打开模态框
      boxData : [],
      dataMsg : {},
      boxType: ''
    };
  },
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'TOOL',
    ])
  },
  mounted () {

    this.$bus.on('Modal_vue', (data) => { // 打开弹窗
      if(!this.judge){
        this.judge = true;
      }
      this.$bus.emit('FeaturesPop_close_vue',{
        type : 3
      });
      this.boxData.push(data.name);
      this.dataMsg[data.name] = data.data;
      this.boxType = data.data && data.data.type || '';
    });
    this.$bus.on('Modal_close_vue', (data) => { // 关闭弹窗
      let index = this.boxData.indexOf(data.name);
      if (index > -1) {
        this.boxData.splice(index, 1);
      }
      delete this.dataMsg[data.name];
      if(!this.boxData.length){
        this.judge = false;
      }
    });
  },
  methods: {

  },
  components: {
    Style,
    Internet,
    Preview,
    Hand,
    QuickManu,
    UploadFilLoading,
    Writehand,
    DelVip,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
  width: 100%;
  height: 100%;

   > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue